import React from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import Pageteam from './Pageteam'
import Titlepage from './Titlepage'
import Team2 from './Team2'
import Footer from '../Home/Footer'
import { CartProvider } from 'react-use-cart'


function AllTechnicians() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <Pageteam/>
        <Titlepage/>
        <Team2/>
        <Footer/>
    </CartProvider>
  )
}

export default AllTechnicians